import { IContextualMenuItem, IContextualMenuListProps } from '@fluentui/react/lib/ContextualMenu';
import { IIconProps, Icon } from "@fluentui/react/lib/Icon";
import { ISearchBoxStyles, SearchBox } from '@fluentui/react/lib/SearchBox';
import { IRenderFunction } from '@fluentui/react/lib/Utilities';
import { AppBar, Box, CircularProgress, Toolbar } from "@mui/material";
import { styled } from '@mui/material/styles';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthProvider/useAuth";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { Organization, OrganizationPermission } from "../../model/OrganizationModel";
import { TagReturn } from "../../model/Tags";
import { WorkSpace } from "../../model/WorkSpaceModel";
import { RemoveOrganizationLocalStorage, RemoveWorkspaceLocalStorage } from "../../pages/PublicLayout/RedirectManager";
import { GetAllTags } from "../../services/TagService";
import CommandBar from "../CommandBar/CommandBar";
import { ContentbarProps, ISelectList } from "../Contentbar/ContentSide/ContentSideComp";
import { Searchbox } from "../Searchbox/Searchbox";
import { GetWorkspaceForNav } from "./GetWorkspaceForNav/GetWorkspaceForNav";
import styles from "./Navbar.module.css";
import { KeyDriveBreadcrumb } from '../KeydriveComponents/Breadcrumb/KeyDriveBreadcrumb';
import { KeyDriveChip } from '../KeydriveComponents/Tags/KeyDriveChip';
import useExtractPlan from '../../hooks/useExtractPlan';
import KeydriveTooltip from '../KeydriveComponents/Tooltip/KeydriveTooltip';

export enum SearchMode {
  Workspace = "workspace",
  Temporality = "temporality",
  None = "none",
}

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    ref={props.ref}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#818181",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#818181",
    borderRadius: "8px",
    padding: "8px"
  },
}));

const chevronRightMedIcon: IIconProps = {
  iconName: 'ChevronRightMed',
  style: {
    fontSize: "12px",
    padding: 5,
    marginTop: "auto",
    marginBottom: "auto"
  }
};
interface NavbarProps {
  Organization: Organization | undefined;
  Workspace: WorkSpace | undefined;
  OrgWorkspace: WorkSpace | undefined;
  OrgValidation: WorkSpace | undefined;
  contentbar: ContentbarProps<ISelectList>[];
  updateContentbar: () => void;
  resetIdSelected: () => void;
  isCollapsed: boolean;
  setSearchboxFocus: (e: boolean) => void;
  searchboxFocus: boolean;
  searchMode: SearchMode;
  loadSignture: boolean;
}

const Navbar: React.FC<NavbarProps> = ({loadSignture, isCollapsed, Organization, Workspace, OrgWorkspace, OrgValidation, contentbar, updateContentbar, resetIdSelected, searchboxFocus, setSearchboxFocus , searchMode}) => {
  const MenuHamb = () => <Icon iconName="CollapseMenu" className={isActive ? styles.iconMobileActived : styles.iconMobile} />;
  const [isActive, setActive] = useState(false);
  const navegate = useNavigate();
  const auth = useAuth();
  const profile = useProfile();
  const { t } = useTranslation();
  const [itemsOrgWorkspace, setItemsWorkspace] = useState<IContextualMenuItem[]>([]);
  const [searshName, setSearshName] = useState<string>("");
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const liRef = useRef<HTMLLIElement | null>(null)

  const [items, setItems] = useState<IContextualMenuItem[]>([]);
  const [textSearsh, setTextSearsh] = useState<string>("");
  const [isOrganizationPage, setIsOrganizationPage] = useState<boolean>(false)
  const [tagReturn, setTagReturn] = useState<TagReturn[]>([]);
  const { idWorkspace, nameOrg } = useParams();
  const menuRef = useRef(null);
  useOutsideMenu(menuRef);

  function verifyUserGuest(): boolean {
    return profile?.signtureInformation?.allOrganizationUsers
                  .filter(user => user.permission == OrganizationPermission.GUEST)
                  .map(user => user.userId)
                  .includes(profile?.id!)!
  }

  function useOutsideMenu(ref: MutableRefObject<any>) {
    useEffect(() => {
      function handleClickMenu(event: Event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setActive(isActive);
        }
      }
      document.addEventListener("mousedown", handleClickMenu);
      return () => {
        document.removeEventListener("mousedown", handleClickMenu);
      };
    }, [ref]);
  }


  useEffect(() => {
    if (idWorkspace != undefined) {
      GetAllTags(idWorkspace, 0, 15, searshName.replace("#", "%23"), [])
        .then((tags) => {
          setTagReturn(tags)
        })
        .catch((erro) => {
          console.log("eerr", erro)
        })
    }
  }, [idWorkspace, searshName])

  useEffect(() => {
    if (window.location.pathname === "/") {
      setIsOrganizationPage(true)
    } else {
      setIsOrganizationPage(false)
    }
  }, [window.location.pathname])

  const onAbort = React.useCallback(() => {
    setItems([]);
  }, []);
  const onAbortOrgWorks = React.useCallback(() => {
    setItemsWorkspace([]);
  }, []);
  const onChange = React.useCallback((ev: React.ChangeEvent<HTMLInputElement> | undefined, newValue: string | undefined) => {
    if (newValue != undefined) {
      setTextSearsh(newValue);
    }
    else {
      setTextSearsh("");
    }
  }, []);

  useEffect(() => {
    if (Organization != undefined && Organization.internalName != undefined) {
      GetWorkspaceForNav(Organization.internalName, textSearsh.toLowerCase()).then((filteretWOkspace) => {
        setItensWorkspce(filteretWOkspace);
      });
    }
  }, [textSearsh]);


  useEffect(() => {
    if (Organization?.internalName != undefined) {
      GetWorkspaceForNav(Organization.internalName, undefined).then((filteretWOkspace) => {
        setItensWorkspce(filteretWOkspace);
      });
    }
  }, [Organization, Organization?.internalName]);

  function setItensWorkspce(filteretWOkspace: WorkSpace[]) {
    let filteredItems: IContextualMenuItem[] = [];

    if (!filteretWOkspace || !filteretWOkspace.length) {
      filteredItems.push({
        key: 'no_results',
        onRender: (item, dismissMenu) => (
          <div key="no_results" style={filteredItemsStyle}>
            <Icon iconName="SearchIssue" />
            <span>{t("NotFound.message")}</span>
          </div>
        ),
      });
    }
    else {
      filteretWOkspace.forEach((workspace) => {
        if (workspace.id != undefined) {
          filteredItems.push({
            key: workspace.id?.toString(),
            text: workspace.name,
            onClick: sendToWorkspaceRoot,
          });
        }
      });
    }

    setItems(filteredItems);
  }

  const sendToWorkspaceRoot = (ev?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, item?: IContextualMenuItem) => {
    if (ev)
      ev.preventDefault();

    navegate("/" + Organization?.internalName + "/wsallowed/" + item?.key);
  };

  const renderMenuList: IRenderFunction<IContextualMenuListProps> =
    (
      menuListProps: IContextualMenuListProps | undefined,
      defaultRender: IRenderFunction<IContextualMenuListProps> | undefined) => {
      if (menuListProps != undefined && defaultRender != undefined) {
        return (
          <div style={{ borderBottomLeftRadius: '10px', borderBottomRightRadius: '10px', borderTopRightRadius: '10px', height: '180px' }}>
            <div style={{ padding: '10px' }}>
              <SearchBox
                onAbort={onAbort}
                onChange={onChange}
                styles={searchBoxStyles}
                value={textSearsh}
                placeholder={t("Navbar.placeholderImputText")}
                showIcon
              />
            </div>
            {defaultRender(menuListProps)}
          </div>
        );
      }
      else {
        return null;
      }
    };

  function navegateOrg() {
    resetIdSelected();
    if (nameOrg) {
      navegate(`/${nameOrg}`);
      RemoveWorkspaceLocalStorage();
    } else {
      navegate(`/`);
      RemoveOrganizationLocalStorage();
      RemoveWorkspaceLocalStorage();
    }
  }

  function navegateToListOrg() {
      navegate(`/${nameOrg}`);
      RemoveWorkspaceLocalStorage();
  }

  useEffect(() => {
    const timer = setTimeout(() => {

      if (searshName != undefined || searshName != "") {

        let tag = searchParams.get("tag");

        if ((tag == "" || tag == undefined) && searshName[0] != "#") {
          searchParams.set("search", searshName);
        }

        if (isChecked == true) {
          searchParams.set("folder", "true");
        }
        else {
          searchParams.delete("folder");
        }

        setSearchParams(searchParams);
      }

      if (searshName == "") {
        searchParams.delete("search");
        searchParams.delete("tag");
        setSearchParams(searchParams);
      }

    }, 500)

    return () => clearTimeout(timer)
  }, [searshName, isChecked])

  return (
    <AppBar
      sx={{
        width: `${isCollapsed ? "calc(100% - 66px)" : "calc(100% - 220px)"}`,
        height: "66px",
        backgroundColor: "white",
        borderBottom: "1px solid #0000001A",
        borderLeft: "1px solid #0000001A",
        transition: "width 0.3s ease"
      }}
      elevation={0}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between"
        }}
      >
        <KeyDriveBreadcrumb/>
        <Box
          display="flex"
          alignItems="center"
        >
          <Searchbox
            placeholder={t("Search.message")}
            searchboxFocus={searchboxFocus}
            setSearchboxFocus={setSearchboxFocus}
            idWorkspace={idWorkspace!}
          />
          { loadSignture ? (
            <>
              <CircularProgress variant='indeterminate' />
            </>
          ) : (
            <KeydriveTooltip
              title={`${t("Signture.UnderSignture")} ${verifyUserGuest() ? t("Common.Guest") : profile?.signtureInformation?.planName!}`}
            >
              <Box ml="4px" sx={{
                cursor:"pointer"
              }}>
                { verifyUserGuest() ? (
                    <KeyDriveChip
                      text={t("Common.Guest")}
                    />
                  ) : (
                    <KeyDriveChip
                      text={profile?.signtureInformation?.planName!}
                    />
                  )}
              </Box>
            </KeydriveTooltip>
          ) }
            <CommandBar />
          </Box>
      </Toolbar>
    </AppBar>
  );
};

const filteredItemsStyle: React.CSSProperties = {
  width: '100%',
  height: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};
const searchBoxStyles: ISearchBoxStyles = {
  root: {
    width: '240px',
    marginTop: '10px',
    borderRadius: '8px',
    border: '1px solid #989898',
    opacity: 1,
  },
  icon: {
    color: '#989898',
    fontWeight: 600
  }
};

export default Navbar;
